import {usePrescriptionRoles} from '@/shared/hooks/use-permissions'
import {PatientTherapySequence} from '@cypro/engine/schema'
import {canStartPatientTherapyRemake} from '@cypro/engine/utils'

export function useCanStartRemake(sequence: PatientTherapySequence) {
  return canStartPatientTherapyRemake(sequence, usePrescriptionRoles())
}
